import { render, staticRenderFns } from "./Hoghugh.vue?vue&type=template&id=307afa00"
import script from "./Hoghugh.vue?vue&type=script&lang=js"
export * from "./Hoghugh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports